import './styles.scss';
import React from 'react';
import track from 'react-tracking';
import PropTypes from 'prop-types';
import { ChevronRight } from '@edx/paragon/icons';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';

const messages = defineMessages({
  'prospectus.breadcrumbs.breadcrumb_label': {
    id: 'prospectus.breadcrumbs.breadcrumb_label',
    defaultMessage: 'breadcrumb',
    description: 'Screenreader label describing the breadcrumb navigation.',
  },
  'prospectus.breadcrumbs.spacer_label': {
    id: 'prospectus.breadcrumbs.spacer_label',
    defaultMessage: 'spacer',
    description: 'Screenreader label describing the a visual spacer between links.',
  },
});

function BaseBreadcrumbs({ activeLabel, intl, links }) {
  const updatedLinks = [{ label: 'Home', href: '/' }, ...links];
  const linkCount = updatedLinks.length;

  return (
    <nav aria-label={intl.formatMessage(messages['prospectus.breadcrumbs.breadcrumb_label'])}>
      <ol className="breadcrumb-list list-inline">
        {updatedLinks.map(({
          href,
          label,
          subject = undefined,
        }, i) => (
          <React.Fragment key={href}>
            <li className="breadcrumb-item">
              <ProspectusLink
                href={href}
                className="small muted-link topic-white-breadcrumb"
                analytics={{
                  eventName: 'edx.bi.link.subject-routing.clicked',
                  linkProps: {
                    location: 'routing',
                    subject,
                  },
                }}
              >{label}
              </ProspectusLink>
            </li>
            {(activeLabel || ((i + 1) < linkCount))
                && (
                <li role="presentation" aria-label={intl.formatMessage(messages['prospectus.breadcrumbs.spacer_label'])}>
                  <ChevronRight className="spacer" />
                </li>
                )}
          </React.Fragment>
        ))}
        {activeLabel && <li className="breadcrumb-item" key="active">{activeLabel}</li>}
      </ol>
    </nav>
  );
}

BaseBreadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    href: PropTypes.string,
    subject: PropTypes.string,
  })).isRequired,
  activeLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  intl: intlShape.isRequired,
};

BaseBreadcrumbs.defaultProps = {
  activeLabel: undefined,
};

export default track({
  component: 'breadcrumbs',
})(injectIntl(BaseBreadcrumbs));
